// Main entry point for SimpleButton components
import SimpleButton from './SimpleButton';
import ButtonLink from './ButtonLink';

export { ButtonLink };
export default SimpleButton;
